import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchCustomColumns } from '../api/customColumnsApi';

import { customColumnKeys } from './keys';

export const customColumnsOptions = () =>
	queryOptions({
		queryKey: customColumnKeys.list(),
		queryFn: fetchCustomColumns,
		staleTime: STALE_TIMES.STANDARD,
	});

export function useCustomColumns() {
	return useQuery(customColumnsOptions());
}
